var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createSelector } from 'reselect';
import * as actions from '../actions/statistics.actions';
import * as moment from 'moment-timezone';
var initialState = {
    filters: {
        dateFrom: moment()
            .tz('Australia/Adelaide')
            .startOf('day')
            .subtract(30, 'days')
            .toDate(),
        dateTo: moment()
            .tz('Australia/Adelaide')
            .endOf('day')
            .toDate()
    },
    customers: {
        loading: false
    },
    memos: {
        loading: false
    },
    members: {
        loading: false
    }
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actions.REQUEST_MEMO_STATISTICS:
            return __assign({}, state, { memos: __assign({}, state.memos, { loading: true }) });
        case actions.RESPONSE_SUCCESS_MEMO_STATISTICS:
            return __assign({}, state, { memos: { loading: false, data: action.payload } });
        case actions.RESPONSE_FAIL_MEMO_STATISTICS:
            return __assign({}, state, { memos: __assign({}, state.memos, { loading: false, error: action.payload }) });
        case actions.REQUEST_MEMBERS_STATISTICS:
            return __assign({}, state, { members: __assign({}, state.members, { loading: true }) });
        case actions.RESPONSE_SUCCESS_MEMBERS_STATISTICS:
            return __assign({}, state, { members: { loading: false, data: action.payload } });
        case actions.RESPONSE_FAIL_MEMBERS_STATISTICS:
            return __assign({}, state, { members: __assign({}, state.members, { loading: false, error: action.payload }) });
        case actions.REQUEST_CUSTOMERS_STATISTICS:
            return __assign({}, state, { customers: __assign({}, state.customers, { loading: true }) });
        case actions.RESPONSE_SUCCESS_CUSTOMERS_STATISTICS:
            return __assign({}, state, { customers: { loading: false, data: action.payload } });
        case actions.RESPONSE_FAIL_CUSTOMERS_STATISTICS:
            return __assign({}, state, { customers: __assign({}, state.customers, { loading: false, error: action.payload }) });
        default:
            return state;
    }
}
export var createSelectors = function (rootReducer) { return ({
    getCustomersStats: createSelector(rootReducer, function (state) { return state.customers; }),
    getFilters: createSelector(rootReducer, function (state) { return state.filters; }),
    getMemoStats: createSelector(rootReducer, function (state) { return state.memos; }),
    getMembersStats: createSelector(rootReducer, function (state) { return state.members; }),
    isMemoStatsLoading: createSelector(rootReducer, function (state) { return state.memos.loading; })
}); };
